export default __webpack_public_path__ + "static/media/notetakerpic3.76da9bf1.png";